/*globals Swiper*/

import QueryUtil from 'common/util/QueryUtil';
import HistoryUtil from 'common/util/HistoryUtil';
import CookieSet from 'common/util/CookieSet';
import './compare-page-d.scss';

class ComparePageDesktop {
	static select = $context => $context.select('.compare-page-d');

	_type = '';
	_filter = '';
	_is_same_prepared = false;

	constructor($page) {
		this.$page = $page;
		this.CompareSet = CookieSet('shop_compare');

		this.bindEvents();
		this.initSwiper();
		this.init();
	}

	get type() {
		return this._type;
	}

	set type(type) {
		this._type = type;
		this.$page.trigger('compare_change_type', type);

		const url = `?type=${type}`;
		HistoryUtil.pushState({}, '', url);
	}

	get filter() {
		return this._filter;
	}

	set filter(filter) {
		this._filter = filter;
		this.$page.trigger('compare_change_filter', filter);
	}

	get items_count() {
		return this.$page.find('.compare-page-d__products-item').length;
	}

	bindEvents() {
		const self = this;

		self.$page.on('click', '.compare-page-d__filter-option', function() {
			const $option = $(this);
			if ($option.hasClass('js-active')) {
				return;
			}

			self.filter = $option.data('value');
		});

		self.$page.on('compare_change_filter', this.handleChangeFilter);

		self.$page.on('change', '.compare-page-d__type-select', function() {
			const $type_select = $(this);
			const type = $type_select.val();

			self.handleChangeTypeSelect(type);
		});

		self.$page.on('compare_change_type', this.handleChangeType);

		self.$page.on('compare_update', this.handleUpdate);

		self.$page.on('click', '.compare-card-d__option_remove', function() {
			const $card = $(this).closest('.compare-card-d');
			const id = $card.data('id');

			self.deleteItem(id);
		});

		self.$page.on('click', '.compare-page-d__delete', function() {
			self.deleteAllItems();
		});

		$(window).on('popstate', () => {
			const params = QueryUtil.parse(location.href);
			let type = QueryUtil.find(params, 'type');
			if (!type) {
				type = {
					name: 'type',
					value: self.$page.find('.compare-page-d__type-select option:first').val()
				};
			}

			if (type.value && type.value !== self.type) {
				this.updateContents(type.value, true);
			}
		});

		$(window).on('scroll', this.handleScroll);
	}

	updateContents(type, push = false) {
		const url = `?type=${type}`;

		$.get(url, html => {
			const $html = $(html);

			this.$page
				.find('.compare-page-d__content')
				.html($html.find('.compare-page-d__content').html());

			if (push) {
				this._type = type;
			}

			this.triggerUpdate();
		});
	}

	initSwiper() {
		const $breakpoint = $('.compare-page-d__breakpoint_offset-left');
		const offset = $breakpoint.offset().left;

		const swiper_config = {
			spaceBetween: 0,
			slidesPerView: 8,
			slidesOffsetBefore: offset,
			slidesOffsetAfter: offset,
			watchSlidesVisibility: true,
			watchSlidesProgress: true,
			loopFillGroupWithBlank: true,
			observer: true,
			observeSlideChildren: true
		};

		const $products = this.$page.find('.compare-page-d__products');
		this.products_swiper = new Swiper($products.get(0), {
			wrapperClass: 'compare-page-d__products-list',
			slideClass: 'compare-page-d__products-item',
			navigation: {
				prevEl: this.$page.find('.compare-page-d__prev-button').get(0),
				nextEl: this.$page.find('.compare-page-d__next-button').get(0)
			},
			...swiper_config
		});

		const $rows = this.$page.find('.compare-page-d__rows');
		this.rows_swiper = new Swiper($rows.get(0), {
			wrapperClass: 'compare-page-d__rows-list',
			slideClass: 'compare-page-d__rows-item',
			navigation: {
				//prevEl: $compare_page.find('.c-compare-page__prev-arrow').get(0),
				//nextEl: $compare_page.find('.c-compare-page__next-arrow').get(0)
			},
			...swiper_config
		});

		this.rows_swiper.controller.control = this.products_swiper;
		this.products_swiper.controller.control = this.rows_swiper;
	}

	init() {
		if (this.items_count <= 6) {
			this.$page.addClass('compare-page-d_disabled-navigation');
		}
	}

	deleteAllItems() {
		const self = this;
		$('.compare-page-d__products-item').each(function() {
			const id = $(this).data('id');
			self.deleteItem(id);
		});
	}

	deleteItem(id) {
		const $product = $(`.compare-page-d__products-item[data-id=${id}]`);
		const $row = $(`.compare-page-d__rows-item[data-id=${id}]`);

		if (!$product.length || !$row.length) {
			return;
		}

		$product.remove();
		$row.remove();

		this.products_swiper.updateSlides();
		this.products_swiper.slideToClosest();
		this.rows_swiper.updateSlides();
		this.rows_swiper.slideToClosest();

		this.CompareSet.remove(id);

		const $total_count = this.$page.find('.compare-page-d__products-total-count');
		const total_count = parseInt($total_count.html()) - 1;
		$total_count.html(total_count);

		if (total_count === 0) {
			location.reload();
			return;
		}

		const $type_select = this.$page.find('.compare-page-d__type-select');
		const $type = $type_select.find('option:selected');
		const $type_label = $('<div/>').html($type.data('label'));
		const $typed_count = $type_label.find('.compare-page-d__products-count');
		const typed_count = parseInt($typed_count.html()) - 1;
		$typed_count.html(typed_count);
		$type.attr('data-label', $type_label.html());
		$type.data('label', $type_label.html());
		$type_select.trigger('refresh');

		if (typed_count === 0) {
			HistoryUtil.reloadWithoutQuery();
			return;
		}
	}

	prepareSameItems() {
		if (this._is_same_prepared) {
			return;
		}

		const feature_values = {};
		this.$page.find('.compare-row-d__list-item').each(function() {
			const $item = $(this);
			const feature_id = $item.data('feature-id');
			const feature_value = JSON.stringify($item.data('feature-value'));
			if (!(feature_id in feature_values)) {
				feature_values[feature_id] = {};
			}

			if (feature_value in feature_values[feature_id]) {
				feature_values[feature_id][feature_value]++;
			} else {
				feature_values[feature_id][feature_value] = 1;
			}
		});

		Object.entries(feature_values).map(([feature_id, feature_feature_values]) => {
			if (Object.keys(feature_feature_values).length === 1) {
				this.$page
					.find(`.compare-row-d__list-item[data-feature-id="${feature_id}"]`)
					.addClass('compare-row-d__list-item_same');
			}
		});

		this._is_same_prepared = true;
	}

	handleChangeFilter = () => {
		const self = this;

		this.$page.find('.compare-page-d__filter-option').each(function() {
			const $option = $(this);
			const filter = $option.data('value');

			if (filter === self.filter) {
				$option.addClass('js-active');
			} else {
				$option.removeClass('js-active');
			}
		});

		if (this.filter === 'differing') {
			this.prepareSameItems();
			this.$page.find('.compare-row-d__list-item_same').hide();
		} else {
			this.$page.find('.compare-row-d__list-item').show();
		}
	};

	handleChangeTypeSelect(type) {
		this.type = type;
	}

	handleChangeType = () => {
		this.updateContents(this.type);
	};

	handleUpdate = () => {
		this.initSwiper();
	};

	handleScroll = () => {
		const $products_wrapper = this.$page.find('.compare-page-d__products-wrapper');

		const $breakpoint = this.$page.find('.compare-page-d__breakpoint_offset-top');
		const options_height = $breakpoint[0].offsetHeight;
		const options_offset = $breakpoint.offset().top;
		const is_sticky = options_offset + options_height < window.pageYOffset;
		$products_wrapper.toggleClass('compare-page-d__products-wrapper_sticky', is_sticky);
	};

	triggerUpdate() {
		Update(this.$page);
		this.$page.trigger('compare_update');
	}
}

export default () => Component(ComparePageDesktop.select, $page => new ComparePageDesktop($page));
